<div class="bp-family-grid">
  @for (group of groupedByFamily; track group.family.code) {
    <div class="card">
      <div class="ct" style="margin-bottom:10px">{{ group.family.label }}</div>
      <div style="display:flex;flex-direction:column;gap:8px">
        @for (bilan of group.bilans; track bilan.code) {
          <label class="bilan-picker-row" [class.disabled]="disabled">
            <input
              type="checkbox"
              [checked]="isSelected(bilan.code)"
              [disabled]="disabled"
              (change)="onToggle(bilan.code)">
            <span>{{ bilan.name }}</span>
          </label>
        }
      </div>
    </div>
  }
</div>
